import React from 'react';
import { createComponent } from '@lit/react';
import { IxIconButton as LitComp } from '../IxIconButton.js';

customElements.define('ix-icon-button', LitComp);

export const IxButton = createComponent({
  tagName: 'ix-icon-button-react',
  elementClass: LitComp,
  react: React,
});
